var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcFti(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#d9d9d9",
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 20.8V2.6q0-.175.15-.237.15-.063.275.062l.725.725a.48.48 0 0 0 .7 0l.8-.8a.48.48 0 0 1 .7 0l.8.8a.48.48 0 0 0 .7 0l.8-.8a.48.48 0 0 1 .7 0l.8.8a.48.48 0 0 0 .7 0l.8-.8a.48.48 0 0 1 .7 0l.8.8a.48.48 0 0 0 .7 0l.8-.8a.48.48 0 0 1 .7 0l.8.8a.48.48 0 0 0 .7 0l.8-.8a.48.48 0 0 1 .7 0l.8.8a.48.48 0 0 0 .7 0l.725-.725q.125-.125.275-.062.15.062.15.237v18.2q0 .35-.3.475-.3.126-.55-.125l-.3-.3a.48.48 0 0 0-.7 0l-.8.8a.48.48 0 0 1-.7 0l-.8-.8a.48.48 0 0 0-.7 0l-.8.8a.48.48 0 0 1-.7 0l-.8-.8a.48.48 0 0 0-.7 0l-.8.8a.48.48 0 0 1-.7 0l-.8-.8a.48.48 0 0 0-.7 0l-.8.8a.48.48 0 0 1-.7 0l-.8-.8a.48.48 0 0 0-.7 0l-.8.8a.48.48 0 0 1-.7 0l-.8-.8a.48.48 0 0 0-.7 0l-.3.3q-.25.25-.55.125-.3-.124-.3-.475M7 17h10q.424 0 .712-.287A.97.97 0 0 0 18 16a.97.97 0 0 0-.288-.712A.97.97 0 0 0 17 15H7a.97.97 0 0 0-.713.288A.97.97 0 0 0 6 16q0 .425.287.713Q6.576 17 7 17m0-4h10q.424 0 .712-.287A.97.97 0 0 0 18 12a.97.97 0 0 0-.288-.712A.97.97 0 0 0 17 11H7a.97.97 0 0 0-.713.288A.97.97 0 0 0 6 12q0 .426.287.713Q6.576 13 7 13m0-4h10q.424 0 .712-.287A.97.97 0 0 0 18 8a.97.97 0 0 0-.288-.712A.97.97 0 0 0 17 7H7a.97.97 0 0 0-.713.288A.97.97 0 0 0 6 8q0 .426.287.713Q6.576 9 7 9",
    fill: "#001a52"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFti);
export default __webpack_public_path__ + "static/media/ic_fti.94c225d4d6df25d6bb39a8f5d7044fe6.svg";
export { ForwardRef as ReactComponent };